import { StopOutlined } from '@ant-design/icons';
import { Card, Result } from 'antd';
import React from 'react';
import LogosEmpresaAseguradora from '../../components/LogosEmpresaAseguradora';
import ResponsiveContainer from '../../components/ResponsiveContainer';
import { InspeccionProvider } from '../../context/inspeccion-context';
import { isMobile } from '../../utils';
import SolicitanteSteps from './solicitante/steps/SolicitanteSteps';

function InspeccionForm(props) {
  return (
    <>
      <LogosEmpresaAseguradora />
      <ResponsiveContainer size="large">
        {isMobile ? (
          <InspeccionProvider>
            <SolicitanteSteps props={props} />
          </InspeccionProvider>
        ) : (
          <Card>
            <Result
              icon={<StopOutlined />}
              title="Debe acceder desde un dispositivo móvil"
            />
          </Card>
        )}
      </ResponsiveContainer>
    </>
  );
}

export default InspeccionForm;
